import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import Router from './Router';

// --- CAPTURE DU LOGIN CRM (HORS COMPOSANT POUR ETRE LE PREMIER) ---
const urlParams = new URLSearchParams(window.location.search);
const login = urlParams.get('login') || urlParams.get('token');
const name = urlParams.get('name'); // Ton URL utilise 'name'

if (login) {
  // On sauvegarde immédiatement dans le localStorage
  const userSession = {
    login: login,
    nom: name || login,
    role: 'admin' // Par défaut car c'est ton cas
  };
  localStorage.setItem("am_user", JSON.stringify(userSession));
  console.log("✅ Session CRM capturée :", login);
}
// ----------------------------------------------------------------

const App = () => {
  return (
    <BrowserRouter>
      <main>
        <Router />
      </main>
    </BrowserRouter>
  );
};

export default App;
